export default __webpack_public_path__ + "static/media/nepal.91f4a3c8.gif";